<template>
  <AlertConfirmModal ref="alertConfirmModal"/>
  <div class="header">
    <div class="container-fluid">
      <div class="header-left">
        <v-icon icon="mdi-menu" size="lg" class="app-menu-trigger" @click="$parent.appMenuTrigger"/>
        <div class="logo-container clickable" @click="goToDashboard">
          <img src="@/assets/images/Icon-128x128.png" class="logo-img" alt="">
          <div class="logo-text">
            <div class="logo-title" :title="version">OneConsole</div>
            <div class="logo-version" :title="getVersion">v{{ getVersion }}</div>
          </div>
        </div>
      </div>
      <div class="header-nav" role="navigation">
        <AppHeaderDropdownCid />
        <AppHeaderDropdownNotif/>
        <AppHeaderDropdownAccount @logout="handleLogout"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Desktop styles (keeps your current layout) */
.header .container-fluid {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
}

.app-menu-trigger {
  margin-right: 15px;
  cursor: pointer;
  float: left;
}

.logo-container {
  width: var(--cui-sidebar-width, 0);
  display: flex;
  align-items: end;
}

.logo-img {
  width: 45px;
  margin-right: 20px;
}

.logo-title {
  color: #6c6c6c;
  font-size: 1.5em;
}

.logo-version {
  color: #6c6c6c;
  font-size: 8px;
  align-self: end;
  text-align: right;
}

.clickable {
  cursor: pointer;
}

.header-nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Mobile styles */
@media (max-width: 768px) {
  .header .container-fluid {
    padding: 10px 12px;
    gap: 8px;
  }

  .header-left {
    gap: 10px;
    min-width: 0;
    flex: 1;
  }

  .app-menu-trigger {
    margin-right: 0;
    float: none;
  }

  .logo-container {
    width: auto;
    flex: 1;
    min-width: 0;
    gap: 10px;
  }

  .logo-img {
    width: 38px;
    margin-right: 0;
  }

  .logo-text {
    min-width: 0;
    overflow: hidden;
  }

  .logo-title {
    font-size: 1.3em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .logo-version {
    font-size: 7px;
  }

  .header-nav {
    gap: 4px;
    flex-shrink: 0;
  }
}

/* Small mobile */
@media (max-width: 576px) {
  .header .container-fluid {
    padding: 8px 10px;
  }

  .logo-img {
    width: 32px;
  }

  .logo-title {
    font-size: 1.1em;
  }

  .logo-version {
    font-size: 6px;
  }

  .app-menu-trigger {
    font-size: 20px !important;
  }
}

/* Extra small mobile */
@media (max-width: 400px) {
  .logo-img {
    width: 28px;
  }

  .logo-title {
    font-size: 1em;
  }
}
</style>

<script>
import AppHeaderDropdownCid from "./AppHeaderDropdownCid"
import AppHeaderDropdownNotif from "./AppHeaderDropdownNotif"
// import AppHeaderDepartment from "./AppHeaderDepartment"
import AppHeaderDropdownAccount from "./AppHeaderDropdownAccount"
import Version from "@/scripts/version"
import imanager3Appframe from "@/scripts/imanager3-appframe";
import iStoreUtils from "@/scripts/istore-utils.js"

export default {
  name: 'AppHeader',
  components: {
    // AppHeaderDepartment,
    AppHeaderDropdownAccount,
    AppHeaderDropdownCid,
    AppHeaderDropdownNotif
  },
  data() {
    return {
      version: Version
    }
  },
  created() {
  },
  methods: {
    goToRoleDefault() {
      const isReseller = (this.$store.state.loginUser.roles || []).some(r => r.name === 'orion_reseller')
      if (isReseller) {
        const target = (this.$store.state.loginUser.userFunctions || []).find(
          f => f.module === 'cloudPlugin' && f.name === 'starNumInfo'
        )
        if (target) {
          this.$store.commit('setCurrentMenu', target)
          this.$store.commit('setChosenUrlValidity', true)
          // Navigate to home layout so AppFrame renders currentMenu
          if (this.$route.path !== '/home') {
            this.$router.replace('/home')
          } else {
            this.$router.replace({ path: '/home', query: { target: 'starNumInfo', ts: Date.now() } })
          }
          return true
        }
      }
      return false
    },
    goToDashboard() {
      if (this.goToRoleDefault()) return

      this.sendTrackingAction(
        this.$store.state.loginUser.userId,
        "Load Page",
        {
          "page": "Dashboard"
        }
      )
      if (this.$route.path !== '/dashboard') {
        this.$router.replace('/dashboard')
      }
      this.$store.commit('setCurrentMenu')
    },
    showHideSidebar() {
      this.$store.commit('toggleUnfoldable')
      if (!this.$store.state.sidebarVisible) {
        this.$store.commit('toggleSidebar')
      }
    },
    async handleLogout(message) {
      const modalInstance = this.$refs.alertConfirmModal
      const confirmed = await modalInstance.openModal(message, true)
      if (confirmed) {
        modalInstance.isVisible = false
        this.sendTrackingAction(
          this.$store.state.loginUser.userId,
          "Logout Success",
          {
            "page": "AppHeader"
          }
        ).then(() => {
          this.$store.commit('setLogoutClicked', true)
          this.$store.commit('setCurrentMenu')
          this.$store.dispatch('logOut')
        })
      }
    },
    async sendTrackingAction(starNumber, action, data){
      await imanager3Appframe.sendTrackingAction({
        starNumber: starNumber,
        pluginName: "main",
        uuid: iStoreUtils.generateTrackingUuid(),
        userAction: action,
        data: data
      })
    }
  },
  computed: {
    getVersion() {
      return Version
      // if (Subversion) {
      //   return Version + '-' + Subversion
      // } else {
      //   return Version
      // }
    },
  }
}
</script>
